<template>
    <BaseModal
        is-disabled-padding-tablet
        is-disabled-panel-overflowx-dialog
        :is-open="isOpen"
        class="overflow-y-hidden"
        @close="closeModal">
        <button
            style="
                cursor:
                    url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                    pointer;
            "
            @click="closeModal"
            class="absolute inset-0 size-full outline-none" />
        <div class="relative">
            <div
                class="pointer-events-none absolute right-0 top-0 z-50 h-screen">
                <div
                    class="pointer-events-none relative z-[80] flex h-full flex-col items-end justify-evenly p-5">
                    <div
                        :class="isCromi() ? 'space-x-5' : 'space-x-10'"
                        class="pointer-events-auto flex w-full justify-between">
                        <BurgerMenuPhone
                            v-for="(contact, index) in Object.values(contacts)"
                            :key="index"
                            :title="contact.title"
                            :description="contact.address"
                            :phone-link="contact.tel">
                            {{ contact.phone }}
                        </BurgerMenuPhone>

                        <div class="text-16/150 font-semibold text-ash">
                            <p>Электронная почта</p>
                            <div class="flex items-center text-accent">
                                <NuxtLink
                                    :to="`mailto:${readyEmailForCopy}`"
                                    class="break-all font-semibold transition-colors duration-300 hover:text-accent-700">
                                    <span ref="emailCromi">
                                        info@cromi.ru
                                    </span>
                                </NuxtLink>
                                <BaseCopyButton
                                    size="small"
                                    done-color-accent
                                    :text-to-copy="readyEmailForCopy" />
                            </div>
                            <p
                                :class="isCromi() ? '' : 'max-w-[9.75rem]'"
                                class="mt-0.5 text-12/116 font-medium">
                                *Такой адрес защищает нас от&nbsp;спама
                            </p>
                        </div>

                        <button
                            class="flex items-center text-accent"
                            @click="closeModal">
                            <AtomIcon
                                name="close"
                                class="size-7" />
                        </button>
                    </div>

                    <div
                        v-if="config.public.website !== 'radioguide.rent'"
                        class="flex w-full justify-between">
                        <p
                            v-if="isRent()"
                            class="w-full text-48/100 font-semibold text-accent-400 md:ml-32">
                            Аренда:
                        </p>
                        <div
                            role="search"
                            :class="isCromi() ? '' : 'ml-auto max-w-[85%]'"
                            class="pointer-events-auto my-3 flex w-full items-center rounded-full border border-accent px-5 text-accent">
                            <input
                                placeholder="Введите Ваш запрос..."
                                class="w-full rounded-20 py-3 tracking-wider placeholder-accent-100 outline-none placeholder:text-16/120 placeholder:font-semibold placeholder:tracking-wider"
                                @click="openSearchModal" />
                            <button aria-label="поиск">
                                <AtomIcon
                                    name="search"
                                    class="size-10" />
                            </button>
                        </div>
                    </div>

                    <NuxtLink
                        v-if="isRadioguide()"
                        to="/"
                        class="pointer-events-auto relative z-50 flex h-full max-h-[17.375rem] w-full max-w-[50.5rem] items-end justify-end p-5"
                        @click="closeModal">
                        <picture>
                            <source
                                srcset="
                                    /assets/images/ui/other/webp/burger-menu-link-radioguide-rent.webp
                                "
                                type="image/webp" />
                            <img
                                width="808"
                                height="277"
                                alt="Обложка радиогида"
                                src="/assets/images/ui/other/jpg-png/burger-menu-link-radioguide-rent.png"
                                class="absolute inset-0 z-0 h-full w-full" />
                        </picture>
                        <p
                            class="relative z-10 inline-flex items-center text-20/120 font-semibold text-ash-200">
                            Радиогиды в аренду
                            <AtomIcon
                                name="arrow-right"
                                class="ml-2" />
                        </p>
                    </NuxtLink>

                    <div class="pointer-events-auto flex gap-4 xl:gap-5">
                        <BurgerMenuCategories
                            v-if="config.public.website !== 'radioguide.rent'"
                            @click="closeModal" />
                    </div>

                    <div
                        :class="isCromi() ? '' : 'space-x-7 xl:space-x-9'"
                        class="pointer-events-auto flex w-full justify-end text-16/132 font-semibold leading-5 text-accent md:max-w-fit">
                        <div
                            v-for="(group, index) in linksGroupsByDirection"
                            :key="index"
                            :class="[
                                isCromi() ? 'min-w-[9.5rem]' : '',
                                isCromi() && index == 0 ? 'mr-12' : '',
                                isCromi() && index == 1 ? 'mr-14' : '',

                                isRent() && index == 0 ? '!mr-10' : '',
                                isRent() && index == 1 ? '!mr-6' : '',
                            ]"
                            class="flex max-w-xs flex-col space-y-3">
                            <NuxtLink
                                v-for="link in group"
                                :key="link.title"
                                :to="link.to"
                                class="transition-colors duration-300 hover:text-accent-700"
                                @click="closeModal">
                                {{ link.title }}
                            </NuxtLink>
                        </div>
                    </div>

                    <div
                        class="pointer-events-auto mt-1 flex items-center space-x-5">
                        <AtomButton
                            appearance="accent"
                            @click="openFeedback">
                            Отправить заявку
                        </AtomButton>
                        <BaseMessengerLink
                            aria-label="Перейти в ватсап"
                            icon="whatsapp-outline"
                            :link="whatsAppLink" />
                        <BaseMessengerLink
                            icon="max-outline"
                            aria-label="Перейти в MAX"
                            :link="messengers.max.link" />
                        <BaseMessengerLink
                            icon="telegram-outline"
                            aria-label="Перейти в телеграм"
                            :link="messengers.telegram.link" />
                    </div>
                </div>
            </div>

            <div
                class="relative right-0 top-0 z-40 h-dvh min-h-[900px] w-auto max-lg:max-w-[65rem]">
                <div
                    style="
                        cursor:
                            url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                            pointer;
                    "
                    class="absolute left-40 top-0 z-40 h-[21.875rem] w-[45.5rem] rounded-full bg-accent outline-none blur-[7rem]"
                    @click="closeModal" />
                <div
                    style="
                        cursor:
                            url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                            pointer;
                    "
                    class="absolute -bottom-14 right-2 z-30 h-[21.875rem] w-[56.25rem] rounded-full bg-accent outline-none blur-[7rem]"
                    @click="closeModal" />
                <div
                    style="
                        cursor:
                            url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                            pointer;
                        clip-path: path(
                            'M 2.03117 28.1232 L 424.314 902.123 C 427.485 908.687 434.132 912.857 540.421 1144.857 H 2 V 28.1232 Z'
                        );
                    "
                    class="absolute -bottom-9 -left-10 z-50 h-[57.25rem] w-[63rem] outline-none"
                    @click="closeModal"></div>
                <button
                    style="
                        cursor:
                            url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                            pointer;
                    "
                    class="absolute z-40 size-full outline-none"
                    @click="closeModal" />

                <svg
                    width="1008"
                    height="912"
                    viewBox="0 0 1008 912"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="absolute top-0 z-40 h-dvh min-h-[900px] w-auto max-lg:right-0 max-lg:max-w-[75rem] lg:max-xl:-right-4 xl:right-0">
                    <polygon
                        points="500,900 0,0 0,1000"
                        style="
                            fill: transparent;
                            stroke: none;
                            position: relative;
                            cursor:
                                url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                                pointer;
                            z-index: 100;
                            stroke-width: 0;
                        "
                        @click="closeModal" />

                    <path
                        d="M1.91594 27.2658C-4.17983 14.6493 5.01186 0 19.0237 0H988.242C998.735 0 1007.24 8.50659 1007.24 19V893C1007.24 903.493 998.735 912 988.242 912H441.306C434.017 912 427.37 907.829 424.198 901.266L1.91594 27.2658Z"
                        fill="white" />
                </svg>

                <!--
                <svg
                    width="1228"
                    height="912"
                    viewBox="0 0 1228 912"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="absolute top-0 z-40 h-dvh min-h-[900px] w-auto max-lg:right-0 max-lg:max-w-[75rem] lg:max-xl:-right-4 xl:right-0">
                    <polygon
                        points="500,900 0,0 0,1000"
                        style="
                            fill: transparent;
                            stroke: none;
                            position: relative;
                            cursor:
                                url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                                pointer;
                            z-index: 100;
                            stroke-width: 0;
                        "
                        @click="closeModal" />

                    <path
                        d="M1.91569 27.2658C-4.18007 14.6493 5.01162 0 19.0235 0H1208.24C1218.73 0 1227.24 8.50659 1227.24 19V893C1227.24 903.493 1218.73 912 1208.24 912H441.306C434.016 912 427.369 907.829 424.198 901.266L1.91569 27.2658Z"
                        fill="white" />
                </svg>

                -->
            </div>
        </div>
    </BaseModal>
</template>

<script setup lang="ts">
import { useMutationObserver } from '@vueuse/core'
import { contacts, messengers } from '~/const/company-info.consts'

import AtomButton from '~/components/atom/atom-button/AtomButton.vue'
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import BaseCopyButton from '~/components/base/base-copy-button/BaseCopyButton.vue'
import BaseMessengerLink from '~/components/base/base-messenger-link/BaseMessengerLink.vue'
import BaseModal from '~/components/base/base-modal/BaseModal.vue'
import BurgerMenuCategories from '~/components/modals/burger-menu/BurgerMenuCategories.vue'
import BurgerMenuPhone from '~/components/modals/burger-menu/BurgerMenuPhone.vue'

const props = defineProps({
    isOpen: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const modalStore = useModalStore()
const config = useRuntimeConfig()
const route = useRoute()

const { data } = await useContactSettings()

const whatsAppLink = computed(() => {
    if (!data.value) return messengers.whatsApp.link

    const api = 'https://api.whatsapp.com/send'
    const phone = String(data.value.data.whatsApp_phone).replace(/^\+7/, '')

    return `${api}?phone=${phone}&text=${data.value.data.whatsApp_message}`
})

const isSticky = ref(false)

watch(
    () => props.isOpen,
    () => {
        isSticky.value = window.scrollY > 0
    }
)

const emailCromi = useTemplateRef('emailCromi')
const readyEmailForCopy = ref('info@cromi.ru')

onMounted(() => {
    useMutationObserver(
        emailCromi,
        (mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === 'characterData' ||
                    mutation.type === 'childList'
                ) {
                    readyEmailForCopy.value =
                        emailCromi.value?.textContent || 'info@cromi.ru'
                }
            })
        },
        {
            characterData: true,
            childList: true,
            subtree: true,
        }
    )
})

const linkGroups = [
    [
        {
            title: 'Аренда оборудования',
            to: '/rent',
        },
        {
            title: 'Решения',
            to: '/solutions',
        },
        {
            title: 'О компании',
            to: '/about',
        },
        {
            title: 'Контакты',
            to: '/contacts',
        },
        {
            title: 'Отзывы',
            to: '/reviews',
        },
    ],
    [
        {
            title: 'Портфолио',
            to: '/portfolio',
        },
        {
            title: 'СМИ о нас',
            to: '/media',
        },
        {
            title: 'Гарантия и сервис',
            to: '/warranty-and-service',
        },
        {
            title: 'Вопрос-ответ',
            to: '/faq',
        },
    ],
    [
        {
            title: 'Доставка и оплата',
            to: '/delivery-and-payment',
        },
        {
            title: 'Блог PRO',
            to: '/pro',
        },
        {
            title: 'Видео',
            to: '/videos',
        },
        {
            title: 'Новости',
            to: '/news',
        },
    ],
]

const linkGroupsRadioguide = [
    [
        {
            title: 'Доставка по Санкт-Петербургу и Москве',
            to: '/delivery-msk-and-spb',
        },
        {
            title: 'Доставка в другие города России',
            to: '/delivery-russia',
        },
        {
            title: 'Условия оплаты для физ. и юр. лиц',
            to: '/pay',
        },
        {
            title: 'Купить такое оборудование',
            to: 'https://cromi.ru/radioguide',
        },
        {
            title: 'О компании',
            to: '/about',
        },
    ],
    [
        {
            title: 'Отзывы',
            to: '/reviews',
        },
        {
            title: 'Вопрос-ответ',
            to: '/faq',
        },
        {
            title: 'Опыт',
            to: '/portfolio',
        },
        {
            title: 'Блог PRO',
            to: '/pro',
        },
        {
            title: 'Видео',
            to: '/videos',
        },
        {
            title: 'Контакты',
            to: '/contacts',
        },
    ],
]
const linkGroupsRent = [
    [
        {
            title: 'Продажа оборудования',
            to: '/sale',
        },
        {
            title: 'О компании',
            to: '/about',
        },
        {
            title: 'Контакты',
            to: '/contacts',
        },
        {
            title: 'Отзывы',
            to: '/reviews',
        },
    ],
    [
        {
            title: 'Портфолио',
            to: '/portfolio',
        },
        {
            title: 'Вопрос-ответ',
            to: '/faq',
        },
        {
            title: 'Блог PRO',
            to: '/pro',
        },
        {
            title: 'Видео',
            to: '/videos',
        },
    ],
]

const linksGroupsByDirection = computed(() => {
    if (isRent()) return linkGroupsRent
    if (isRadioguide()) return linkGroupsRadioguide
    return linkGroups
})

const emits = defineEmits(['close', 'openSearchModal'])

function closeModal() {
    emits('close')
}

function openSearchModal() {
    closeModal()
    emits('openSearchModal')
}

function openFeedback() {
    emits('close')
    modalStore.setFeedbackLabel(modalStore.headerFeedbackLabel)
    modalStore.setFormName('Бургер-меню, кнопка "Связаться"')

    if (isCromi() && route.name === 'direction-subcategory') {
        modalStore.setFormID(5)
    }

    modalStore.open('feedbackModal')
}
</script>
